import React from "react";
import { Input } from "@campgladiator/cgui-core.atoms.input";
import { FormPart } from "@campgladiator/cgui-core.molecules.form-part";
import { Paragraph } from "@campgladiator/cgui-core.atoms.typography";
import {
  ItemProps,
  ListMenu,
} from "@campgladiator/cgui-core.molecules.list-menu";
import {
  ProductSubType,
  ProductType,
  ProgramScheduleDTO,
  TrainerProgramApproval,
} from "@campgladiator/cg-common.types.types";
import useSelectTrainer from "./useSelectTrainer";
import styles from "./SelectTrainerInput.module.scss";

export type SelectedTrainer = ItemProps & {
  programSchedules: ProgramScheduleDTO[];
};

export type SelectTrainerInputProps = {
  approvedProgram: TrainerProgramApproval[];
  onClearTrainerSearch: () => void;
  onItemSelect: (id: SelectedTrainer) => void;
  selectedProductType: ProductType;
  selectedProductSubType: ProductSubType;
  selectedTrainer?: SelectedTrainer;
  setIsTrainerLoading: (isLoading: boolean) => void;
  setTrainerProgramSchedules: (programSchedules: ProgramScheduleDTO[]) => void;
  isDisabled?: boolean;
};

const SelectTrainerInput = ({
  approvedProgram,
  onClearTrainerSearch,
  onItemSelect,
  selectedProductSubType,
  selectedProductType,
  selectedTrainer,
  setIsTrainerLoading,
  setTrainerProgramSchedules,
  isDisabled,
}: SelectTrainerInputProps) => {
  const {
    filteredTrainers,
    placeHolderText,
    searchFieldRef,
    showList,
    userInput,
    getSearchBarIcon,
    handleOnCancelIconClick,
    handleOnChange,
  } = useSelectTrainer({
    approvedProgram,
    onClearTrainerSearch,
    onItemSelect,
    selectedTrainer,
    setTrainerProgramSchedules,
    setIsTrainerLoading,
    selectedProductSubType,
    selectedProductType,
  });
  const isListMenuVisible = userInput && showList;

  return (
    <FormPart
      className={styles.searchForm}
      forId="searchForm"
      label="Search for a Trainer"
    >
      <div ref={searchFieldRef}>
        <Input
          id="searchField"
          name="searchField"
          placeholder={placeHolderText}
          value={userInput}
          onChange={handleOnChange}
          icon={getSearchBarIcon(userInput)}
          onIconClick={handleOnCancelIconClick}
          avatar={{ src: selectedTrainer?.avatar?.src }}
          disabled={isDisabled}
        />
        {isDisabled && (
          <Paragraph
            size="small"
            weight="book"
            className={styles.disabledLabel}
          >
            Select a product to enable trainer search.
          </Paragraph>
        )}

        {isListMenuVisible && (
          <ListMenu
            className={styles.menu}
            selection="single"
            style={{ height: "initial" }}
            items={filteredTrainers}
            size="small"
          />
        )}
      </div>
    </FormPart>
  );
};

export default SelectTrainerInput;
